import Vue from 'vue'
import Vuex from 'vuex'

import * as navstate from './navstate'
import * as appbar from '../shared/vuex/appbarstate'
import * as assetxp from '../vuex/assetxpstate'
import * as datacleansing from '../vuex/datacleansingstate'
import * as productsearch from '../vuex/productsearchstate'
import * as sessionState from './sessionstate.js'
import Authentication from './authentication'
import workspace from './workspace'

Vue.use(Vuex)

export default new Vuex.Store({
  modules : {
    "navstate" : navstate.navstate,
    "appbarstate" : appbar.appbarstate,
    "assetxpstate" : assetxp.assetxpstate,
    "datacleansingstate" : datacleansing.datacleansingstate,
    "productsearchstate" : productsearch.productsearchstate,
    "authentication" : Authentication,
    "sessionState" : sessionState.SessionState,
    "workspace" : workspace,
  }
})
